import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { setHeaderType, setLoading } from '../../Redux/ActionCreater';
import { Helmet } from 'react-helmet-async';
import { FaFilePdf } from "react-icons/fa6";
// import Fil1 from "../../../public/files/Form_MGT_7A_2022-23.pdf"

function InvestorRelations() {
  let dispatch = useDispatch()

  useEffect(() => {

    setTimeout(() => {
      dispatch(setLoading(false))

    }, 2000);
    //window.scrollTo(0, 0);
  }, [])

  useEffect(() => {
    dispatch(setHeaderType(2))
  }, []);

  const files = [
    {
      title: "Annual Return FY 2023-24",
      url: "/files/Form_MGT_7A_2023-24.pdf"
    },
    {
      title: "Annual Return FY 2022-23",
      url: "/files/Form_MGT_7A_2022-23.pdf"
    },
    {
      title: "Annual Return FY 2021-22",
      url: "/files/Form_MGT_7A_2021-22.pdf"
    },
    {
      title: "Annual Return FY 2020-21",
      url: "/files/Form_MGT_7A_2020-21.pdf"
    },
    {
      title: "Annual Return FY 2019-20",
      url: "/files/Form_MGT_7_2019-20.pdf"
    },
    {
      title: "Annual Return FY 2018-19",
      url: "/files/Form_MGT_7_2018-19.pdf"
    }
  ];

  return (
    <>
      <Helmet>
        <title>Bintix::Investor Relations</title>
        <meta property="og:title" content="Bintix::Investor Relations" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <section className='details-sec'>
        <div className='container'>
          <div className='detaslheding policy-text'>
            <h3 className='mb-4'>Investor Relations </h3>
            <div className='row'>
              {
                files.map((file, key) => {
                  return <div key={key} className='col-md-2'>
                    <div className='card' style={{
                      padding: '15px',
                      background: '#FFF',
                      alignItems: 'center',
                      cursor: 'pointer',
                      color: '#36204D',
                      boxShadow: '0 4px 10px 0 #0000001a',
                      borderColor: '#36204D'
                    }}
                      onClick={() => window.open(file.url, '_blank')}
                    >
                      <FaFilePdf size={80} />
                      <p style={{
                        fontFamily: 'Poppins',
                        paddingTop: '15px',
                        textAlign: 'center'
                      }}>{file.title}</p>
                    </div>
                  </div>
                })
              }
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default InvestorRelations